import { withStyles } from '@material-ui/core/styles';
import { ToggleButton } from '@material-ui/lab';
import color from 'color';

const StyledToggleButton = withStyles(theme => ({
  root: {
    maxWidth: 271,
    width: '100%',
    height: 50,
    color: '#3A3A3A',
    borderColor: '#c3cece',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '20px',
    lineHeight: '24px',
    textTransform: 'none',
    borderRadius: 4,

    [theme.breakpoints.up('sm')]: {
      borderRadius: 50,
    },

    '&$selected': {
      fontWeight: 600,
      backgroundColor: '#FBE27E',
      color: theme.palette.primary.main,
      boxShadow: 'inset 0px 0px 21.09px #FFCC00',
      '&:hover': {
        backgroundColor: color('#FBE27E')
          .darken(0.2)
          .hex(),
      },
    },
  },
  sizeLarge: {
    height: 60,
  },
  selected: {},
}))(ToggleButton);

export default StyledToggleButton;
